import {
	API,
	Auth
} from 'aws-amplify'


export default async function (httpMethod: string, apiName: string, path: string, body = {}) {

	let user = null
	let accessToken = null
	let payload = {}

	// check for logged in user
	try{
		user = await Auth.currentSession()
		accessToken = user.getAccessToken()

		payload = {
			headers: {
				Authorization: `Bearer ${(user)
					.getIdToken()
					.getJwtToken()}`
			},
			body: body
		}
	}
	catch(e) {
		console.error(e)
	}

    let result
    try {
		// run query or mutation
		if(user && accessToken) {
			switch(httpMethod) {
				case 'post':
					result = await API.post(apiName, path, payload)
					break
				case 'get':
					result = await API.get(apiName, path, payload)
					break
				case 'patch':
					result = await API.patch(apiName, path, payload)
					break
				case 'put':
					result = await API.put(apiName, path, payload)
					break
				case 'delete':
					result = await API.del(apiName, path, payload)
					break
				default:
					throw 'Unsupported http method'
			}
		}
    }
    catch(err) {
		console.error(err)
		// if logged out, refresh token or log out
		result = err
		throw err
    }

    return result
}